import React from 'react';
import { Grid } from '@material-ui/core';
import { toUpper } from 'lodash';
import cs from 'classnames';
import Proptypes from 'prop-types';
import FormSection from '../../../../components/FormComponents/FormSection';
import TextInputFieldWithValidation from '../../../../components/ValidationFormElements/TextInputFieldWithValidation';
import MainCheckbox from '../../../../components/MUI/MainCheckbox/MainCheckbox';
import Validation from '../../../../components/Validation/Validation';

import DamageCauseIcon from '../../../../img/formSectionIcons/damageCause.svg';
import styles from '../../../CompensationContainer/Steps/steps.module.scss';

const DamageCause = ({
  formProps: { errors, register, clearError },
  i18n,
  damageCauses,
  selectedDamageCauses,
  handleDamageCausesChange,
}) => (
  <FormSection title="propertyClaim.accInfo.damageCause" icon={DamageCauseIcon}>
    <Validation name="damageCauses" errors={errors}>
      <Grid container spacing={4} style={{ marginBottom: 10 }}>
        {damageCauses.map((damageCause) => (
          <Grid
            item
            xs={12}
            sm={6}
            key={damageCause.id}
          >
            <label
              className={cs(styles.agreement, {
                [styles.invalid]: !!errors.damageCauses,
              })}
              htmlFor="damageCauses"
            >
              <MainCheckbox
                checked={selectedDamageCauses.some(
                  (selectedDamageCause) => selectedDamageCause.id === damageCause.id,
                )}
                value={damageCause}
                onChange={(e) => {
                  handleDamageCausesChange(damageCause, e.target.checked);
                }}
                color="primary"
              />
              <span
                className={styles.agreementText}
                dangerouslySetInnerHTML={{
                  __html: damageCause[`name${toUpper(i18n.language)}`],
                }}
              />
            </label>
          </Grid>
        ))}
      </Grid>
    </Validation>
    <Grid container spacing={4} style={{ marginBottom: 10 }}>
      {selectedDamageCauses.some((selectedDamageCause) => selectedDamageCause.label === 'other') && (
        <Grid item xs={12}>
          <TextInputFieldWithValidation
            labelKey="propertyClaim.accInfo.damageCauseOther"
            name="damageCauseOther"
            register={register}
            multiline
            rows={4}
            formProps={
              {
                errors,
                clearError,
              }
            }
          />
        </Grid>
      )}
    </Grid>
  </FormSection>
);

DamageCause.propTypes = {
  formProps: Proptypes.shape({
    errors: Proptypes.shape({
      damageCauses: Proptypes.shape({}),
    }),
    clearError: Proptypes.func,
    register: Proptypes.func,
  }).isRequired,
  damageCauses: Proptypes.arrayOf(Proptypes.shape({})),
  selectedDamageCauses: Proptypes.arrayOf(Proptypes.shape({})),
  i18n: Proptypes.shape({
    language: Proptypes.string,
  }).isRequired,
  handleDamageCausesChange: Proptypes.func.isRequired,
};

DamageCause.defaultProps = {
  damageCauses: [],
  selectedDamageCauses: [],
};

export default DamageCause;
